import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import { device } from '../utils/breakpoints';

const CTAWrapper = styled.section`
  background: linear-gradient(135deg, #0A1929 0%, #0F2744 100%);
  padding: 100px 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 70% 30%, rgba(255, 215, 0, 0.12) 0%, transparent 50%),
      radial-gradient(circle at 30% 70%, rgba(124, 179, 66, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 50% 50%, rgba(255, 107, 53, 0.08) 0%, transparent 50%);
  }
  
  @media ${device.tablet} {
    padding: 60px 0;
  }
`;

const CTAContent = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
`;

const CTATitle = styled.h2`
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 24px;
  
  @media ${device.tablet} {
    font-size: 32px;
  }
`;

const CTASubtitle = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 40px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  
  @media ${device.tablet} {
    font-size: 18px;
  }
`;

const CTAButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

const PrimaryButton = styled(Link)`
  background: linear-gradient(135deg, #FFD700 0%, #FF6B35 100%);
  color: #0F2744;
  padding: 18px 40px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 215, 0, 0.5);
    background: linear-gradient(135deg, #FFE84D 0%, #FF8652 100%);
    color: #0F2744;
    text-decoration: none;
  }
`;

const SecondaryButton = styled(Link)`
  background: transparent;
  color: white;
  padding: 18px 40px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  border: 2px solid rgba(124, 179, 66, 0.5);
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(124, 179, 66, 0.15);
    border-color: #7CB342;
    color: white;
    text-decoration: none;
  }
`;

const CTASection = () => {
  return (
    <CTAWrapper>
      <Container>
        <Row>
          <Col>
            <CTAContent>
              <CTATitle>Explore Whether Ametnes Is a Fit</CTATitle>
              <CTASubtitle>
                Start with a working session to understand your data and AI initiatives, identify governance 
                or operational friction, and explore whether a standardized private foundation would help.
              </CTASubtitle>
              <CTAButtons>
                <PrimaryButton to="/contact">
                  Schedule Working Session
                </PrimaryButton>
                <SecondaryButton to="/platform/how-it-works">
                  Learn More
                </SecondaryButton>
              </CTAButtons>
            </CTAContent>
          </Col>
        </Row>
      </Container>
    </CTAWrapper>
  );
};

export default CTASection;


